'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const TABS = [
  { href: '/pipeline', label: 'Pipeline' },
  { href: '/insights', label: 'Insights' },
];

export default function Nav() {
  const pathname = usePathname();
  return (
    <nav className="flex items-center gap-1 bg-gray-100/80 rounded-xl p-1">
      {TABS.map((t) => {
        const active = pathname === t.href;
        return (
          <Link
            key={t.href}
            href={t.href}
            className={`px-3 py-1.5 rounded-lg text-sm font-semibold transition-colors ${
              active ? 'bg-white text-[#0890F1] shadow-sm' : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
